export const translationSolutions_sv = {
  confirmDeleteFreshdeskIntegration:
    'Ta bort Freshdesk-integration "{name}"? Det här kan inte ångras.',
  confirmDeleteHttpIntegration: 'Ta bort HTTP-integration "{name}"? Det här kan inte ångras.',
  confirmDeleteShopifyCredentials:
    "Radera Shopify-autentiseringsuppgifter? Det här kan inte ångras.",
  confirmDeleteMagentoCredentials:
    "Radera Magento-autentiseringsuppgifter? Det här kan inte ångras.",
  confirmDeleteShipmondoCredentials:
    "Radera Shipmondo-autentiseringsuppgifter? Det här kan inte ångras.",
  confirmDeleteCommerceToolsCredentials:
    "Radera CommerceTools-autentiseringsuppgifter? Det här kan inte ångras.",
  confirmDeleteRaptorCredentials: "Radera Raptor-autentiseringsuppgifter? Det här kan inte ångras.",
  confirmRemoveKnowledgeBaseIndex:
    'Ta bort kunskapsbasindex "{namespace}" ({indexName})? Det här kan inte ångras.',
};
